import { useCallback, useState } from 'react';
import classNames from 'classnames';
import { useIonToast, useIonModal } from '@ionic/react';
import { useContextSelector } from 'use-context-selector';
import { useTheme } from 'styled-components';
import { v4 as uuid } from 'uuid';

import { LocalizationContext } from '../../contexts/LocalizationContext';

import { ToastParams, ConfirmParams } from './useUtils.types';
import { Confirm, ConfirmProps } from './_partitions/Confirm/Confirm';
import { DEFAULT_CONFIRM_PROPS } from './useUtils.hook.const';

import styles from './useUtils.module.scss';

export const useUtils = () => {
  const { isDesktop } = useTheme();
  const [showToast] = useIonToast();

  const [confirmParams, setConfirmParams] = useState<ConfirmProps>(
    DEFAULT_CONFIRM_PROPS
  );

  const [showConfirm, dismissConfirm] = useIonModal(Confirm, {
    ...confirmParams,
  });

  const confirmCopy = useContextSelector(
    LocalizationContext,
    ({ confirm }) => confirm
  );

  const toast = useCallback(
    ({ message, variant, duration = 7000 }: ToastParams) => {
      showToast({
        message,
        duration,
        position: 'middle',
        icon: '',
        cssClass: classNames(styles.toast, styles[variant]),
        buttons: [
          {
            text: 'OK',
            cssClass: styles.button,
          },
        ],
      });
    },
    [showToast]
  );

  const confirm = useCallback(
    ({
      message,
      onConfirm,
      icon = 'lifebuoy',
      cancelText = confirmCopy.cancelText,
      confirmText = confirmCopy.confirmText,
    }: ConfirmParams) => {
      setConfirmParams({
        icon,
        message,
        onConfirm,
        cancelText,
        confirmText,
        dissmiss: dismissConfirm,
      });
      showConfirm({
        handle: false,
        initialBreakpoint: 1,
        backdropDismiss: false,
        cssClass: classNames(styles.confirm, {
          [styles.desktop]: isDesktop,
        }),
        breakpoints: !isDesktop ? [0, 1] : undefined,
      });
    },
    [showConfirm, confirmCopy, dismissConfirm, isDesktop]
  );

  return { toast, confirm, uuid };
};
